import { LegalInfoItem } from '@plus-int/acq-toolkit';

export const getTruncatedText = (text: string, maxLength: number) => {
    if (text.length > maxLength) {
        const truncatedText = text.slice(0, maxLength);
        const trimmedText = truncatedText.trim();

        return `${trimmedText.slice(0, -1)}\u2026`;
    }

    return text;
};

type LegalTextPart =
    | string
    | {
          text: string;
          link: string;
      };

const PLACEHOLDER_REGEX = /\{\{([a-zA-Z0-9_-]+)\}\}/g;

export const interpolateOfferText = (
    text: string | undefined,
    legals: LegalInfoItem[] = []
): LegalTextPart[] => {
    const source = text || '';
    const matches = Array.from(source.matchAll(PLACEHOLDER_REGEX));

    const result: LegalTextPart[] = [];
    let cursor = 0;

    matches.forEach((match) => {
        const [placeholder, key] = match;
        const matchIndex = match.index ?? 0;

        const textBeforePlaceholder = source.slice(cursor, matchIndex);
        if (textBeforePlaceholder) {
            result.push(textBeforePlaceholder);
        }

        const item = legals.find((legal) => legal.key === key);
        if (item?.type === 'LINK') {
            result.push({ text: item.data.text, link: item.data.link });
        } else {
            result.push(placeholder);
        }

        cursor = matchIndex + placeholder.length;
    });

    const tail = source.slice(cursor);
    if (tail) {
        result.push(tail);
    }

    return result;
};
